// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e_py","scoreRing":"e_qy","badge":"e_ry","badgeImage":"e_sy","spaced":"e_ty"};